import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

export default class EmbeddedLinkHandler extends React.PureComponent {
  onClick = (e) => {
    const targets = this.element.querySelectorAll(this.props.selector);
    if (_.includes(targets, e.target)) {
      this.props.clickHandler(e);
    }
  }

  setElement = (element) => {
    this.element = element;
  }

  render() {
    const props = {
      ref: this.setElement,
      onClick: this.onClick,
    };

    return this.props.isInline
      ? <span {...props}>{this.props.children}</span>
      : <div {...props}>{this.props.children}</div>;
  }
}
EmbeddedLinkHandler.propTypes = {
  children: PropTypes.element.isRequired,
  clickHandler: PropTypes.func.isRequired,
  selector: PropTypes.string,
  isInline: PropTypes.bool,
};
EmbeddedLinkHandler.defaultProps = {
  selector: 'a',
  isInline: false,
};
